<template>
  <tbody>
    <tr v-for="(row, index) in items" :key="index" class="text-xs-center">
      <td>
        {{row.label}}
      </td>
      <td>
        {{row.total}}
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: ['items'],
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/panel/DueDateList.vue